import React from 'react'
import { Box, Button, Typography, Fade } from '@mui/material'
import { TypeAnimation } from 'react-type-animation'

import header from '../../_contentnew/pulsebanner1.webp'
import { useNavigate } from 'react-router-dom'

const HomepageCarousel = () => {
  const navigate = useNavigate()

  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${header})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: {
            xs: '55vh',
            sm: '70vh',
            md: '85vh'
          },

          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(rgba(34,32,35,0.75), rgba(34,32,35,0.75))',
            zIndex: 1
          },

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
            maxWidth: '900px',
            px: 3
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: {
                xs: '2rem',
                sm: '3rem',
                md: '4.5rem'
              },
              lineHeight: 1.1,
              mb: 3,
              minHeight: {
                xs: '50px',
                sm: '70px',
                md: '90px'
              }
            }}
          >
            <TypeAnimation
              sequence={[
                '',
                1000,
                'Pulse Pallets'
              ]}
              speed={240}
              cursor={false}
              repeat={0}
            />
          </Typography>

          <Fade
            in
            timeout={2200}
          >
            <Box>
              <Typography
                sx={{
                  color: '#C8C8C8',
                  fontSize: {
                    xs: '1rem',
                    sm: '1.2rem',
                    md: '1.4rem'
                  },
                  maxWidth: '700px',
                  mx: 'auto',
                  mb: 5
                }}
              >
                Supplying quality pallets from Basingstoke, Hampshire, helping you
                source reliable pallet solutions quickly and efficiently.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 3,
                  flexWrap: 'wrap'
                }}
              >
                <Button
                  size="large"
                  onClick={() => navigateLink('/contact')}
                  sx={{
                    backgroundColor: '#0A9B48',
                    color: '#fff',
                    minWidth: '220px',
                    py: 2,
                    px: 4,
                    fontSize: '1rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    borderRadius: 0,

                    '&:hover': {
                      backgroundColor: '#57C84D'
                    }
                  }}
                >
                  GET A QUOTE →
                </Button>

                <Button
                  size="large"
                  onClick={() => navigateLink('/pallets')}
                  sx={{
                    border: '2px solid #fff',
                    color: '#fff',
                    minWidth: '220px',
                    py: 2,
                    px: 4,
                    fontSize: '1rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    boxSizing: 'border-box',

                    '&:hover': {
                      border: '2px solid #57C84D',
                      color: '#57C84D',
                      backgroundColor: 'transparent'
                    }
                  }}
                >
                  VIEW PALLETS
                </Button>
              </Box>
            </Box>
          </Fade>
        </Box>
      </Box>
    </Box>
  )
}

export default HomepageCarousel